import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { AddressHelpers } from '../../helpers';

const BillingAddressLayout = ({
  billingAddress,
  email,
  telephone,
  contactName,
}) => (
  <Box
    sx={{ pt: 2, wordBreak: 'break-all' }}
    data-testid='billing-address-container'
  >
    <Typography variant={'body1'}>{contactName}</Typography>
    {AddressHelpers.getBillingAddress(billingAddress).map(str => (
      <Typography variant={'body1'} key={str}>
        {str}
      </Typography>
    ))}
    <Typography variant={'body1'} sx={{ mt: 4 }}>
      {email}
    </Typography>
    <Typography variant={'body1'}>{telephone}</Typography>
  </Box>
);

BillingAddressLayout.propTypes = {
  billingAddress: PropTypes.array,
  email: PropTypes.string,
  telephone: PropTypes.string,
  contactName: PropTypes.string,
};

export default BillingAddressLayout;
